/**
 * 受注一覧
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/driver_schedules/unassigned_orders`

const driver_schedule_unassigned_order = {
  namespaced: true,
  actions: {
    /**
     * 配車計画 受注一覧
     * @param commit
     * @param target_date
     * @returns {Promise<unknown>}
     */
    index ({ commit }, { conditions }) {
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: conditions }).then(data => {
          resolve(data.content)
        })
      })
    },
  },
}
export default driver_schedule_unassigned_order
